// extracted by mini-css-extract-plugin
export default {"items":"items-Zmwc"};